<h3-read-only-table></h3-read-only-table>

@if (isAnnotationPanelOpen$ | async) {
  <h3-bulk-edit-view></h3-bulk-edit-view>
}
